@if (showPam()) {
  <bit-nav-item icon="bwi-lock-encrypted" [text]="'pamAccessRequestsTitle' | i18n" route="pam">
    @if (badgeCount() > 0) {
      <span slot="end" class="tw-flex tw-items-center">
        <span bitBadge variant="primary" size="small">{{ badgeCount() }}</span>
      </span>
    }
  </bit-nav-item>
}
